const KNOWN_ERRORS = {
  '!reg': 'You are not registered yet',
  'Reg': 'You are already registered',
  '!ref': 'Invalid referrer ID',
  '!pkg': 'Invalid package amount. Must be multiple of package unit',
  'BL': 'Your account is blacklisted',
  'Weekend': 'Withdrawals are closed on weekends',
  'Min': 'Below minimum withdrawal amount',
  'Mult': 'Amount must be a multiple of the withdrawal unit',
  'Insuf': 'Insufficient pending balance',
  '!act': 'Account not active',
  '!auth': 'Unauthorized action',
  '!owner': 'Only owner can perform this action',
  '!val': 'Invalid value',
  '!lvl': 'Invalid level',
  '!tz': 'Invalid timezone offset',
  'Max': 'Maximum user limit reached',
  'UT': 'USDT transfer failed. Check balance and allowance',
  'T2': 'Token2 transfer failed. Check balance and allowance',
  '!pending': 'This withdrawal request is no longer pending',
  '!id': 'Invalid withdrawal request ID',
  '!helper': 'Only the helper gateway can call this',
  'insufficient funds': 'Insufficient BNB for gas fees',
  'user rejected': 'Transaction rejected by user',
  'user denied': 'Transaction rejected by user',
  'ACTION_REJECTED': 'Transaction rejected by user'
};

export const parseError = (err) => {
  if (!err) return 'Unknown error';

  const msg = err?.data?.message || err?.error?.message || err?.reason || err?.message || String(err);

  for (const key in KNOWN_ERRORS) {
    if (msg.toLowerCase().includes(key.toLowerCase())) {
      return KNOWN_ERRORS[key];
    }
  }

  const revertMatch = msg.match(/execution reverted:?\s*([^"',}]+)/i);
  if (revertMatch) {
    const reason = revertMatch[1].trim();
    for (const key in KNOWN_ERRORS) {
      if (reason.toLowerCase().includes(key.toLowerCase())) return KNOWN_ERRORS[key];
    }
    return reason;
  }

  if (msg.length > 120) return msg.slice(0, 120) + '...';
  return msg;
};
